import { NgModule } from "@angular/core";
import { NicePipesModule } from "@recursyve/nice-ui-kit.v2";
import { FormatAddressLinePipe } from "./format-address-line.pipe";
import { FormatLongAddressPipe } from "./format-long-address.pipe";
import { FormatShortAddressPipe } from "./format-short-address.pipe";
import { SafeHtmlPipe } from "./safe-html.pipe";

@NgModule({
    imports: [NicePipesModule, FormatLongAddressPipe, FormatShortAddressPipe, FormatAddressLinePipe],
    declarations: [SafeHtmlPipe],
    exports: [FormatLongAddressPipe, SafeHtmlPipe, FormatShortAddressPipe, FormatAddressLinePipe]
})
export class PipesModule {}
